import { ISymbolPoolStoreSegment } from './symbolPool.interface';

export const symbolPoolStoreSelector = (state: ISymbolPoolStoreSegment) => state.symbolPool;
